import { useEffect, useState } from 'react';
import { loadPrintImages, type PrintImageStore } from '../export/printImages';

/**
 * The logo and template images, loaded for previews (sizes + object URLs).
 * Keyed on the files themselves (URLs without their expiring SAS), so a
 * refetch with fresh read tokens doesn't reload everything.
 */
export function usePrintImages(logoUrl: string | null | undefined, assets: readonly { id: string; url: string }[]): PrintImageStore | null {
  const [store, setStore] = useState<PrintImageStore | null>(null);
  const key = [logoUrl?.split('?')[0] ?? '', ...assets.map((a) => `${a.id}=${a.url.split('?')[0]}`)].join('|');
  useEffect(() => {
    let cancelled = false;
    let loaded: PrintImageStore | null = null;
    void loadPrintImages({ logoUrl: logoUrl ?? null, assets }).then((result) => {
      loaded = result;
      if (cancelled) result.dispose();
      else setStore(result);
    });
    return () => {
      cancelled = true;
      loaded?.dispose();
    };
    // The URLs' identity changes with every refetch (fresh SAS); the files decide.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return store;
}
